module.exports = __webpack_public_path__ + "static/media/vaso.073a329b.png";